/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { defineComponent, PropType } from "vue";

export interface IPickerSelectPayload {
  category: string;
  value: string;
}

export default defineComponent({
  name: "PickerMixin",
  emits: ["update:modelValue", "select", "close"],
  props: {
    modelValue: String,
    x: Number,
    y: Number,
    anchor: Object as PropType<HTMLElement>,
    target: Object as PropType<HTMLInputElement>,
  },
  methods: {},
});
